import React from "react";

interface InputProps {
  value: any;
  setValue: React.Dispatch<React.SetStateAction<any>>;
  name: string;
  type: "text" | "number" | "email";
  placeholder?: string;
  disabled?: boolean;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  className?: string;
  min?: number;
  max?: number;
}

const Input: React.FC<InputProps> = ({
  value,
  setValue,
  name,
  disabled,
  type,
  placeholder,
  onKeyDown = () => {},
  onFocus = () => {},
  className = "",
  min,
  max,
}) => {
  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    setValue(e.target.value);
  };

  return (
    <input
      id={name}
      type={type}
      placeholder={placeholder}
      autoComplete="off"
      className={`flex-grow max-w-full p-3 focus:outline-none focus:shadow-outline rounded-lg border ${className}`}
      value={value}
      onFocus={onFocus}
      disabled={disabled}
      onKeyDown={onKeyDown}
      onChange={handleChange}
      min={min}
      max={max}
    />
  );
};

export default Input;
